import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { setChatListInitial } from '../../../actions/chatList';
import { closeChat } from '../../../actions/chatWindow';
import { userSelector } from '../../../selectors';
import { setUserUnauthenticated } from '../../../slices/userSlice';
import { IBroadcastChannelMessageEvent, EBroadcastChannelMessageType } from '../../../types/broadcastChannel';
import { useAppDispatch } from '../../../types/redux/state';
import { ESocketCloseCustomCode } from '../../../types/socket';
import { useApplicationContext } from '../../../utils/applicationContext';

export const useBroadcastChannelEventListener = () => {
  const dispatch = useAppDispatch();

  const { isAuthenticated: isUserAuthenticated } = useSelector(userSelector);

  const {
    broadcastChannel,
    custom: { socket },
  } = useApplicationContext();

  useEffect(() => {
    if (!broadcastChannel) {
      return;
    }

    const handleChannelMessage = (event: MessageEvent<IBroadcastChannelMessageEvent>) => {
      /**
       * @description
       * Триггер этого события происходит в микрофронте чатов (в v2) в аналогичном хуке
       */
      if (event.data.type === EBroadcastChannelMessageType.UserUnauthorize && isUserAuthenticated) {
        dispatch(setChatListInitial());
        dispatch(setUserUnauthenticated());
        dispatch(closeChat());

        if (socket && !socket.eventChannel.isChannelClosed()) {
          socket.eventChannel.closeEventChannel(ESocketCloseCustomCode.UserLogout);
        }
      }
    };

    broadcastChannel.addEventListener('message', handleChannelMessage);

    return () => {
      broadcastChannel.removeEventListener('message', handleChannelMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [broadcastChannel]);
};
